<div class="modal-header">
  <h4 class="modal-title">Tickets Created Details</h4>
  <button
    (click)="close()"
    aria-label="Close"
    class="modal-close"
    type="button"
  >
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <div *ngIf="createdEvents.length === 0" class="text-center py-5">
    <p class="text-muted">No created tickets found.</p>
  </div>

  <div *ngIf="createdEvents.length > 0">
    <!-- Summary Section -->
    <div class="summary-section mb-4">
      <div class="summary-list">
        <div class="summary-item">
          <span class="summary-label">Total Created Ticket:</span>
          <span class="summary-value ms-2">{{
            totalCreatedTicket | number
          }}</span>
        </div>

        <!-- Total Tickets Section -->
        <div
          *ngIf="getTypeOfTicketEntries().length > 0"
          class="summary-subsection"
        >
          <h6 class="summary-subtitle">Type of Tickets</h6>
          <div
            *ngFor="let item of getTypeOfTicketEntries()"
            class="summary-item"
          >
            <span class="summary-label">{{ item.key }}:</span>
            <span class="summary-value">{{ item.value | number }}</span>
          </div>
        </div>

        <!-- Category Section -->
        <div
          *ngIf="getProductCategoryEntries().length > 0"
          class="summary-subsection"
        >
          <h6 class="summary-subtitle">Product Category</h6>
          <div
            *ngFor="let item of getProductCategoryEntries()"
            class="summary-item"
          >
            <span class="summary-label">{{ item.key }}:</span>
            <span class="summary-value">{{ item.value | number }}</span>
          </div>
        </div>

        <!-- Resolution Type Section -->
        <div *ngIf="getResolutionTypeEntries().length > 0" class="summary-subsection">
          <h6 class="summary-subtitle">Resolution</h6>
          <div *ngFor="let item of getResolutionTypeEntries()" class="summary-item">
            <span class="summary-label">{{ item.key }}:</span>
            <span class="summary-value">{{ item.value | number }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
